import React, { useEffect, useState } from 'react'
import { firestore } from '../../../firebase'

function EditInstructions({recipeId}) {

    const [instructions, setInstructions] = useState([])

    useEffect(() => {

        try {
            const instructionsRef = firestore.collection("recipes").doc(recipeId).collection("instructions");

            instructionsRef.orderBy("order").onSnapshot(({docs}) => {
                const instructions = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                })
                setInstructions(instructions)
            })

        } catch (error) {
            
        }

    }, [recipeId])

    async function deleteInstruction(e, instructionId) {
        try {
            const instructionRef = firestore.collection("recipes").doc(recipeId).collection("instructions").doc(instructionId);
            instructionRef.delete();
        } catch (error) {
            
        }
    }

    return (
        <div>
            {instructions && instructions.map((instruction, index) => {
                return (
                    <div key={index} >
                        {instruction.order} {instruction.instruction} 
                        <span className="float-right" onClick={(e) => deleteInstruction(e, instruction.id)}><i className="fas fa-trash"></i></span>
                        <hr/>
                    </div>
                )
            })}
        </div>
    )
}
export default EditInstructions